/**
 * Brand switcher — flips between the Radium Engineering site and the Radium
 * Off-Road design. See snippets/brand-switcher.liquid and
 * assets/brand-switcher.css.
 *
 * Progressive enhancement only: both halves of the pill are already real
 * <a href> links that work on their own. This adds the approved transition
 * (slide the highlight over, show a toast, then navigate ~600ms later) so the
 * brand change doesn't land abruptly. If this file fails to load, clicking
 * still navigates — just instantly.
 *
 * Self-contained: no dependency on pubsub.js / global.js / constants.js, so
 * it can load identically from both layouts regardless of what else they pull
 * in.
 */
(function () {
  'use strict';

  var NAVIGATE_DELAY = 600;
  var SAFETY_RESET_DELAY = 5000;
  var safetyTimer = null;
  var toastEl = null;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getToast() {
    if (toastEl && document.body.contains(toastEl)) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'brand-switch-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.innerHTML = '<div class="spinner" aria-hidden="true"></div><span class="toast-text"></span>';
    document.body.appendChild(toastEl);
    return toastEl;
  }

  function showToast(message) {
    var toast = getToast();
    toast.querySelector('.toast-text').textContent = message;
    // Next frame, so the element is in the DOM with its off-screen start
    // position before the class that animates it in is applied.
    requestAnimationFrame(function () {
      toast.classList.add('show');
    });
  }

  /**
   * Restores the switcher to the state the server rendered it in, and hides
   * the toast. Needed because returning via the browser Back button can
   * restore this page from the back/forward cache exactly as it was left —
   * mid-transition, with the toast still up and the highlight already moved.
   */
  function resetUI() {
    clearTimeout(safetyTimer);
    if (toastEl) toastEl.classList.remove('show');
    document.querySelectorAll('[data-brand-switcher]').forEach(function (wrapper) {
      var wasOffroad = wrapper.getAttribute('data-initial-offroad') === 'true';
      wrapper.classList.toggle('active-offroad', wasOffroad);
    });
  }

  function onSwitchClick(e) {
    var btn = e.currentTarget;
    var href = btn.getAttribute('href');
    if (!href || href === '#') return;

    // Let modified clicks (new tab/window, middle click) behave natively.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    e.preventDefault();

    // Slide every switcher on the page (header and drawer copies both exist
    // in the DOM at once) toward the side being switched to.
    var goingToOffroad = btn.classList.contains('btn-offroad');
    document.querySelectorAll('[data-brand-switcher]').forEach(function (wrapper) {
      wrapper.classList.toggle('active-offroad', goingToOffroad);
    });

    var delay = NAVIGATE_DELAY;
    if (prefersReducedMotion()) {
      delay = 0;
    } else {
      showToast(btn.getAttribute('data-switch-toast') || 'Loading...');
    }

    setTimeout(function () {
      window.location.href = href;
    }, delay);

    // If navigation is blocked or unusually slow, don't leave the toast and
    // the moved highlight stuck on screen.
    safetyTimer = setTimeout(resetUI, SAFETY_RESET_DELAY);
  }

  function init() {
    document.querySelectorAll('[data-brand-switcher] .brand-switch-btn').forEach(function (btn) {
      btn.addEventListener('click', onSwitchClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', resetUI);
})();
